import React, { Component } from 'react';
import { connect } from 'react-redux';
import './content-cta.scss';
import img1 from '../../../../statics/a1.jpg';
import img2 from '../../../../statics/a2.jpg';
import { fromJS } from 'immutable';

class ContentCta extends Component {
  constructor(props) {
    super(props);
  }

  render() {
  
    const { content, space } = this.props;
    const datas = fromJS(content);

    return (
      <div className={`content-cta ${space ? 'noSpace' : ''} `}>
        <div className="content-cta__wrap">
          <div className={`content-cta__container ${datas.get('order') ? 'order' : ''}`}>
            <h2 className="content-cta__container--title">{ datas.get('title') }</h2>
            {
              datas.get('desc').map((item) => {
                return (
                  <p className="content-cta__container--desc" key={ item.get('id') }>{ item.get('l-desc') }</p>
                )
              })
            }
          </div>
          <div className={`content-cta__pic b_img ${datas.get('order') ? 'order' : ''} `}>
            <img className="container-pic" src={ datas.get('id') == 1 ? img1 : img2 } alt=""></img>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(null, null)(ContentCta);
